import { useEffect, useState } from "react";

// Pull authoritative App-Keys aus /api/me/apps (server: loadUserApps -> core.*).
// Statische Listen oder JWT-Claims werden bewusst nicht herangezogen.
//
// Rueckgabe:
//  - allowed: Set<string> | null — null solange laden laeuft.
//  - loading: true bis der Fetch beendet (success oder error) ist.

interface State {
  allowed: Set<string> | null;
  loading: boolean;
}

export function useAllowedApps(): State {
  const [state, setState] = useState<State>({ allowed: null, loading: true });

  useEffect(() => {
    let abort = false;
    fetch("/api/me/apps", { credentials: "include" })
      .then((r) => (r.ok ? r.json() : { apps: [] }))
      .then((data: { apps: string[] }) => {
        if (abort) return;
        setState({ allowed: new Set(data.apps ?? []), loading: false });
      })
      .catch(() => {
        if (abort) return;
        setState({ allowed: new Set(), loading: false });
      });
    return () => {
      abort = true;
    };
  }, []);

  return state;
}
